export default __webpack_public_path__ + "static/media/metamask.4b5d438a.png";